module.exports = function() {
  return new Worker(__webpack_public_path__ + "757f363043f374448010.worker.js");
};